export const IMPERO_HELPDESK_URL = "https://support.impero.com/knowledge";
